import { baseApi } from '../../../shared/api/baseApi';

export interface AnalogDimensionsBody {
    project_id: string;
    organization_id: string;
    product_id: string;
    analog_url: string;
    correct_weight: number;
    correct_length?: number;
    correct_width?: number;
    correct_height?: number;
    transport_length?: number;
    transport_width?: number;
    transport_height?: number;
    transport_weight?: number;
}

export interface AnalogDimensionsRequestDto {
    id: string;
    project_id: string;
    organization_id: string;
    product_id: string;
    user_id: string;
    name: string;
    url: string;
    host: string;
    created_at: string;
    weight: number | null;
    length: number | null;
    height: number | null;
    width: number | null;
    correct_weight: number;
    correct_length: number | null;
    correct_height: number | null;
    correct_width: number | null;
}

export type AnalogDimensionsFieldErrors = Partial<Record<keyof AnalogDimensionsBody, string[]>>;

export const analogDimensionsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        createAnalogDimensions: build.mutation<AnalogDimensionsRequestDto, AnalogDimensionsBody>({
            query: (body) => ({
                url: '/api/admin/incorrect_dimensions/analog',
                method: 'POST',
                body,
            }),
            invalidatesTags: (_result, _error, { product_id }) => [
                { type: 'Products' as const, id: `analogs:${product_id}` },
            ],
        }),
    }),
});

export const { useCreateAnalogDimensionsMutation } = analogDimensionsApi;